<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">添加/编辑审批人介绍</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="120px" class="form">
          <el-form-item label="所属公司">
            <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
              <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="审批人介绍">
            <div class="readme-intro-cont">
              <VueUeditorWrap :config="editorConfig" v-model="form.intro" />
            </div>
          </el-form-item>

          <el-form-item label="">
            <el-button @click="addSealExample()" class="form-btn" type="success">确认添加印章审批人介绍</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import VueUeditorWrap from 'vue-ueditor-wrap'
  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    // mixins: [approvalUsers],
    data() {
      return {
        organizationListData: '',
        form: {
          depId: '',
          intro: '',
          json: true,
        },

        editorConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 450,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 关闭自动保存
          enableAutoSave: false,
          //是否开启字数统计
          wordCount: true,
          //允许的最大字符数 
          maximumWords: 50000,

          toolbars: [
            [
              'fullscreen', 'source', '|', 'undo', 'redo', '|',
              'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript',
              'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor',
              'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
              'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
              'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
              'directionalityltr', 'directionalityrtl', 'indent', '|',
              'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase',
              '|', 'inserttable', 'deletetable',
              'link', 'unlink', 'anchor', '|', 'insertimage', 'attachment', 'insertvideo'
            ]
          ],

          // 上传图片配置项
          'imageMaxSize': 2048000,
          /* 上传大小限制，单位B */
          'imageAllowFiles': ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
          /* 上传图片格式显示 */
          'imageCompressEnable': true,
          /* 是否压缩图片,默认是true */
          'imageCompressBorder': 1600,
          /* 图片压缩最长边限制 */
          'imageInsertAlign': 'none',
          /* 插入的图片浮动方式 */

          // 图片上传路径
          serverUrl: 'http://oaapi.xswater.cn/common/upload'
        }
      }
    },
    created() {
      if (this.$route.query.depId) {
        this.form.depId = this.$route.query.depId / 1
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      if (!this.form.depId) {
        this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      }
    },
    components: {
      VueUeditorWrap
    },
    methods: {
      addSealExample() {
        // console.log(this.form)
        // return
        ajax.post('/seal/approval/example/save', this.form, res => {
          this.$message.success('保存成功')
          this.$router.back()
        })
      },
      getSealExample() {
        ajax.get('/seal/approval/example/' + this.form.depId, '', res => {
          if (res.vo.intro) {
            this.form.intro = res.vo.intro
          }
        })

      },
    },
    watch: {
      "form.depId"() {
        this.getSealExample()
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/readmeCreate.vue